"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogEjecucionResponseSchema = exports.LogEjecucionQuerySchema = exports.CancelarEjecucionResponseSchema = exports.EjecutarAutomatizacionResponseSchema = exports.AutomatizacionEstadoResponseSchema = exports.AutomatizacionesListResponseSchema = exports.AutomatizacionListItemSchema = exports.EjecucionAutomatizacionSchema = exports.AutomatizacionSchema = void 0;
const zod_1 = require("zod");
// ───────────── Automatizaciones (dashboard admin, R14) ─────────────
//
// Read contract for the automations dashboard. Backs the three tables:
//   automatizacion              — the automation definition (codigo, cron, activa)
//   ejecucion_automatizacion    — one row per run (estado, pid, counters, times)
//   item_ejecucion_automatizacion — per-record log of a run (not exposed here yet)
//
// Read layer (list + detail + run history) plus the engine contract: trigger, cancel and the
// live console of host-delegated runs (R67).
// A single automation definition (row of `automatizacion`). May not exist yet for a
// catalog entry that has never been configured — the web layer treats null as "not set up".
exports.AutomatizacionSchema = zod_1.z.object({
    idAutomatizacion: zod_1.z.number().int().positive(),
    codigo: zod_1.z.string(),
    nombre: zod_1.z.string(),
    descripcion: zod_1.z.string().nullable(),
    cron: zod_1.z.string().nullable(),
    activa: zod_1.z.boolean(),
    entidad: zod_1.z.string().nullable(),
});
// One execution run (row of `ejecucion_automatizacion`).
exports.EjecucionAutomatizacionSchema = zod_1.z.object({
    idEjecucion: zod_1.z.number().int().positive(),
    idAutomatizacion: zod_1.z.number().int().positive(),
    idUsuario: zod_1.z.number().int().nullable(),
    nombreUsuario: zod_1.z.string().nullable(),
    fechaInicio: zod_1.z.string(),
    fechaFin: zod_1.z.string().nullable(),
    fechaSolicitudCancelacion: zod_1.z.string().nullable(),
    // EstadoEjecucion: en_curso | finalizada | fallida | cancelada
    estadoEjecucion: zod_1.z.string(),
    // EstadoCancelacion: solicitada | en_curso | finalizada | forzada (null if never asked to cancel)
    estadoCancelacion: zod_1.z.string().nullable(),
    pid: zod_1.z.number().int().nullable(),
    mensajeError: zod_1.z.string().nullable(),
    totalRegistros: zod_1.z.number().int().nonnegative(),
    creados: zod_1.z.number().int().nonnegative(),
    actualizados: zod_1.z.number().int().nonnegative(),
    sinCambios: zod_1.z.number().int().nonnegative(),
    conErrores: zod_1.z.number().int().nonnegative(),
});
// List item: an automation plus its most recent run (if any).
exports.AutomatizacionListItemSchema = zod_1.z.object({
    automatizacion: exports.AutomatizacionSchema,
    ultimaEjecucion: exports.EjecucionAutomatizacionSchema.nullable(),
});
exports.AutomatizacionesListResponseSchema = zod_1.z.object({
    automatizaciones: zod_1.z.array(exports.AutomatizacionListItemSchema),
});
// Detail: the automation (nullable — a catalog codigo may not be configured yet),
// its last run, and the recent run history.
exports.AutomatizacionEstadoResponseSchema = zod_1.z.object({
    codigo: zod_1.z.string(),
    automatizacion: exports.AutomatizacionSchema.nullable(),
    ultimaEjecucion: exports.EjecucionAutomatizacionSchema.nullable(),
    ejecuciones: zod_1.z.array(exports.EjecucionAutomatizacionSchema),
});
// Respuesta del trigger manual. La corrida se ENCOLA: no se ejecuta en el request path
// (un dump puede tardar), así que la API responde apenas el job entra a la cola.
// Las automatizaciones delegadas al host (R67) devuelven además el `idEjecucion` que abrió el
// runner Python, para que el dashboard pueda seguir esa corrida (progreso + consola).
exports.EjecutarAutomatizacionResponseSchema = zod_1.z.object({
    ok: zod_1.z.boolean(),
    mensaje: zod_1.z.string(),
    idEjecucion: zod_1.z.number().int().positive().optional(),
});
// Respuesta de la cancelación de una corrida delegada al host. La API no escribe la fila: el
// runner cancela cooperativamente y la marca él mismo, así que esto solo confirma el pedido.
exports.CancelarEjecucionResponseSchema = zod_1.z.object({
    ok: zod_1.z.boolean(),
    mensaje: zod_1.z.string(),
});
// Consola de una corrida: el log que el runner escribe en el host, leído por tramos.
// `desde`/`siguienteOffset` son offsets en BYTES del archivo, para que el polling solo traiga lo
// nuevo. `truncado` avisa que se omitieron líneas (por el techo de bytes o de líneas).
exports.LogEjecucionQuerySchema = zod_1.z.object({
    desde: zod_1.z.coerce.number().int().nonnegative().default(0),
});
exports.LogEjecucionResponseSchema = zod_1.z.object({
    idEjecucion: zod_1.z.number().int().positive(),
    existe: zod_1.z.boolean(),
    lineas: zod_1.z.array(zod_1.z.string()),
    // La línea que el runner todavía está reescribiendo (barra de tqdm, sin `\n`): se reenvía en
    // cada consulta hasta que se cierra, así la consola muestra el avance sin duplicar líneas.
    lineaParcial: zod_1.z.string().nullable(),
    siguienteOffset: zod_1.z.number().int().nonnegative(),
    truncado: zod_1.z.boolean(),
});
